import { DictationOrigin } from '@highlight/common'
import AsrIpcRouter, { type AsrIpcRouterType } from '@shared/ipc/routers/AsrIpc.router'

class AsrIpcRenderer extends AsrIpcRouter implements AsrIpcRouterType {
  async getASRInputDevices(): Promise<any> {
    return this.exec('getASRInputDevices')
  }

  async saveConversation(): Promise<void> {
    return this.exec('saveConversation')
  }

  async startDictation(callOrigin: DictationOrigin): Promise<void> {
    return this.exec('startDictation', callOrigin)
  }

  async stopDictation(options: { source: number; callOrigin: DictationOrigin; cancelled?: boolean }): Promise<void> {
    return this.exec('stopDictation', options)
  }
}

export default new AsrIpcRenderer()
